export const DialogVariants = {
    Primary: 'primary',
    Danger: 'danger',
    Info: 'info',
    Warning: 'warning',
} as const;

export type DialogVariant = typeof DialogVariants[keyof typeof DialogVariants];

export const DialogSizes = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
} as const;

export type DialogSize = typeof DialogSizes[keyof typeof DialogSizes];

export interface DialogConfig {
    title: string;
    message: string;
    variant?: DialogVariant;
    size?: DialogSize;
    actionText?: string;
    actionIcon?: any;
    cancelText?: string;
    cancelIcon?: any;
    hideNoButton?: boolean;
    data?: any;
}
